import React from 'react';
import PropTypes from 'prop-types';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from 'react-bootstrap';

const FieldGroup = ({
  input,
  meta,
  id,
  label,
  tooltipComponent,
  children,
  customClass,
  manuallyGeneratedError,
  validateWithoutTouched,
  ...rest
}) => {
  const hasError =
    (validateWithoutTouched
      ? meta.error || meta.submitError
      : meta.touched && (meta.error || meta.submitError)) ||
    manuallyGeneratedError;

  return (
    <FormGroup
      controlId={id}
      validationState={hasError ? 'error' : null}
      className={customClass}
    >
      {label && (
        <ControlLabel>
          <div className="flex-inline">
            {label}
            {tooltipComponent}
          </div>
        </ControlLabel>
      )}
      <FormControl {...input} {...rest}>
        {children}
      </FormControl>
      {hasError && (
        <HelpBlock>
          {meta.error || meta.submitError || manuallyGeneratedError}
        </HelpBlock>
      )}
    </FormGroup>
  );
};

FieldGroup.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  // The following props can be provided to be passed through to FormControl
  placeholder: PropTypes.string,
  type: PropTypes.string,
  componentClass: PropTypes.string,
};

export default FieldGroup;
